import { MEDIA_LAYOUT_ICONS } from 'modules/placements/constants';
import { BasicSelectField } from 'lib/iterable-hook-form/';
import { MediaLayout, MediaLayoutMappings } from 'modules/placements/types';
import { BaseOption } from 'ui/selects';
import { capitalizeFirstLetter } from 'utils/helpers';
import { MediaLayoutLabel } from './styles';

const constructMediaLayoutSelectOptions = (): BaseOption<MediaLayout>[] =>
  Object.values(MediaLayout).map((layout) => {
    const label = MediaLayoutMappings[layout];

    return {
      id: layout,
      label: (
        <MediaLayoutLabel>
          {MEDIA_LAYOUT_ICONS[layout]}
          {capitalizeFirstLetter(label)}
        </MediaLayoutLabel>
      ),
      value: layout,
    };
  });

export const MediaLayoutDropdown = () => {
  return (
    <BasicSelectField
      data-test="placement-media-layout-select"
      id="media-layout"
      name="mediaLayout"
      options={constructMediaLayoutSelectOptions()}
      isFullWidth
    />
  );
};
